// FAQ accordion
function toggleFaq(btn) {
  var answer = btn.nextElementSibling;
  var isOpen = answer.classList.contains('open');
  document.querySelectorAll('.faq-a.open').forEach(function(a) { a.classList.remove('open'); });
  document.querySelectorAll('.faq-q.open').forEach(function(q) { q.classList.remove('open'); });
  if (!isOpen) { answer.classList.add('open'); btn.classList.add('open'); }
}

// Scroll fade-in animations
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.1 });
document.querySelectorAll('.fade-in').forEach(function(el) { observer.observe(el); });
